import { render, staticRenderFns } from "./BenefitList.vue?vue&type=template&id=48dc6b20&lang=pug&"
import script from "./BenefitList.vue?vue&type=script&setup=true&lang=js&"
export * from "./BenefitList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports